import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui'
import AVPlugin from 'vue-audio-visual'
import router from './router/router.js'
import store from './store/store.js'
import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-chalk/fonts/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(AVPlugin);

new Vue({
  render: h => h(App),
  router,
  store,
  
}).$mount('#app')
